import React, { Component } from 'react';
import Dropzone from 'react-dropzone';

import { FILE_ACCEPTS } from '../config/list';
import I18n from '../locales/i18n';
import swal from 'sweetalert';

import getFileSize from '../services/getFileSize';

export default class NewEventDropZone extends Component {
	constructor(props) {
		super(props);

		this.state = { acceptedFiles: [], acceptAlerts: false };

		this.onDrop = this.onDrop.bind(this);
		this.onRemoveItem = this.onRemoveItem.bind(this);
		this.setFiles = this.setFiles.bind(this);
	}
	onDrop(Files) {
		const { acceptedFiles } = this.state,
			isSingle = this.props.inputProps.multiple === false,
			{ accept = false } = this.props.inputProps;

		let _arr = acceptedFiles,
			_isAccept = true;

		Files.forEach((file) => {
			if (accept) {
				_isAccept = file.type === accept;
			}
			if (_isAccept) {
				if (file.size < 10000000) {
					if (isSingle) {
						_arr = [file];
					} else {
						acceptedFiles.push(file);
					}
				} else {
					swal(
						'Error',
						`El tamaño del archivo ${file.name} excede el límite`,
						'error'
					);
				}
			} else {
				if (!this.state.acceptAlerts) {
					this.setState({ acceptAlerts: true }, () => {
						setTimeout(() => {
							this.setState({ acceptAlerts: false });
						}, 3000);
					});
				}
			}
		});
		this.setState({ acceptedFiles: isSingle ? _arr : acceptedFiles }, () => {
			this.props.updateFiles(
				this.props.folder,
				isSingle ? _arr : acceptedFiles
			);
		});
	}
	onRemoveItem(e) {
		const { acceptedFiles } = this.state,
			{ value } = e.currentTarget.attributes.getNamedItem('data-index');
		acceptedFiles.splice(value, 1);
		this.setState({ acceptedFiles: acceptedFiles }, () => {
			this.props.updateFiles(this.props.folder, acceptedFiles);
		});
	}
	setFiles(files) {
		this.setState({ acceptedFiles: files });
	}

	render() {
		const { acceptedFiles, acceptAlerts } = this.state,
			isSingle = this.props.inputProps.multiple === false,
			{ accept = false } = this.props.inputProps;

		return (
			<div className="drop-container">
				<Dropzone onDrop={this.onDrop}>
					{({ getRootProps, getInputProps }) => (
						<section className="drop-zone">
							<div {...getRootProps()}>
								<input
									{...getInputProps({
										...this.props.inputProps,
									})}
								/>

								<p>
									{I18n(
										'NEW_EVENT',
										isSingle ? 'DRAG_AND_DROP_SINGLE' : 'DRAG_AND_DROP'
									)}{' '}
									<span
										className={
											'drop-accept-alert' + (acceptAlerts ? ' alert' : '')
										}
									>
										{accept
											? I18n('NEW_EVENT', 'FILE_FILTER') + FILE_ACCEPTS[accept]
											: ''}
									</span>
								</p>
								<p>
									<small>
										{I18n('COMMON', 'MAX')} 10MB {I18n('COMMON', 'PER_FILE')}
									</small>
								</p>
							</div>
						</section>
					)}
				</Dropzone>
				<aside>
					<ul>
						{acceptedFiles.map(function (file, index) {
							return (
								<li key={`${index}_${file.path}`}>
									<button
										type="button"
										onClick={this.onRemoveItem}
										data-index={index}
										className="btn-remove"
									>
										<i className="fas fa-times" />
									</button>
									<strong>{file.path}</strong>{' '}
									<small>{getFileSize(file.size)}</small>
								</li>
							);
						}, this)}
					</ul>
				</aside>
			</div>
		);
	}
}
